import * as types from './mutation-types'

export const mutations = {
  [types.SHOPS_LOADING](state) {
    state.shops.loading = true
    state.shops.data = null
    state.shops.error = false
  },
  [types.SHOPS_ERROR](state, error) {
    state.shops.loading = false
    state.shops.data = null
    state.shops.error = error
  },
  [types.SHOPS_COMPLETE](state, payload) {
    state.shops.loading = false
    state.shops.data = payload
    state.shops.error = false
  },
  [types.SHOPS_SEARCHED_LOADING](state) {
    state.shopsSearched.loading = true
    state.shopsSearched.data = null
    state.shopsSearched.error = false
  },
  [types.SHOPS_SEARCHED_ERROR](state, error) {
    state.shopsSearched.loading = false
    state.shopsSearched.data = null
    state.shopsSearched.error = error
  },
  [types.SHOPS_SEARCHED_COMPLETE](state, payload) {
    state.shopsSearched.loading = false
    state.shopsSearched.data = payload
    state.shopsSearched.error = false
  },  
  [types.GET_SERVICES_LOADING](state) {
    state.current.loading = true
    state.services = null
    state.current.error = false
  },
  [types.GET_SERVICES_ERROR](state, error) {
    state.current.loading = false
    state.current.data = null
    state.current.error = error
  },
  [types.SERVICES_CLEAN](state, error) {
    state.services = []
  },  
  [types.GET_SERVICES_COMPLETE](state, payload) {
    state.current.loading = false      
    if(payload) {
      state.services = _.map(payload.services, item => {
        return _.extend({}, item, {
          pieces: 1,
          subTotal: item.price,
          inCart: null,
          oid_server: item.oid,
          oid: `${item.eoid}${item.oid}`,
          options: _.map(item.options, opt => {
            return _.extend({}, opt, {
              min_number: opt.number,
              number: 0,
              subTotal: 0
            })
          })
        })
      })
    }
    state.current.error = false
  },    
  [types.SHOP_DETAIL_LOADING](state) {
    state.current.loading = true
    state.current.error = false
  },
  [types.SHOP_DETAIL_ERROR](state, error) {
    state.current.loading = false
    state.current.data = null
    state.current.error = error
  },
  [types.SHOP_DETAIL_COMPLETE](state, payload) {
    state.current.loading = false
    state.current.data = payload
    if(payload) {
      state.products = _.map(payload.products, item => { 
        return _.extend({}, item, {
          pieces: 1,
          subTotal: item.price,
          inCart: null,
          visible: true
        })
      })
    }
    state.current.error = false
  }, 
  [types.PRODUCTS_FILTER](state, filter) {
    let products = state.products
    products = _.map(products, item => {
      if(item.category !== filter.name) {
        item.visible = !filter.visible
      }
      return item
    })
  },
  [types.PRODUCTS_FILTER_CLEAN](state) {
    state.productsfilterSelected = []
    let products = state.products    
    products = _.map(products, item => {      
      item.visible = true      
      return item
    })
  },
  [types.PRODUCTS_UPDATE_FILTER_SELECTED](state, filter) {
    state.productsfilterSelected = filter
  },
  [types.PRODUCT_UPDATE](state, pu) {
    let products = state.products
    switch(pu.type) {
      case 'ADD_TO_CART':
        products = _.map(products, item => {          
          if(item.oid === pu.product.oid) {            
            item.inCart = true
            item.pieces = pu.product.pieces
            return item
          }
          return item
        })
      break;
      case 'REMOVE_TO_CART':
        products = _.map(products, item => {
          if(item.oid === pu.product.oid) {
            return item.inCart = false
          }
          return item
        })      
      break;
    }
  }, 
  [types.SERVICES_UPDATE](state, pu) {
    let services = state.services
    switch(pu.type) {
      case 'ADD_TO_CART':
        services = _.map(services, item => {
          _.map(pu.product, item2 => {            
            if(item.oid === item2.oid) {
              item.inCart = true
              item.pieces = item2.pieces
              item.subTotal = item2.subTotal
              item.options = item2.options
              return item
            }
          })
          return item
        })
      break;
      case 'REMOVE_TO_CART':
        services = _.map(services, item => {
          if(item.oid === pu.product.oid) {
            return item.inCart = false
          }
          return item
        })      
      break;
    }
  },    
  [types.SHOP_CURRENT_CLEAN](state) {
    state.current.loading = false
    state.current.data = {}
    state.current.error = false
  }  
}



//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/store/modules/shops/mutations.js
// module id = null
// module chunks = 